import React, { useEffect } from "react";
import { closeAnalyticsExportPopup } from "../Dashboard/actions";

import Button from "modules/Common/Components/Button";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { RootState } from "../../../store";

import Cross from "../../../assets/img/icons/cross.svg";
import { getAllAnalyticsTab, getConstantCampaignEmailId } from "../utils";
import { getQueryAccountId, getQueryContactId } from "utils";
import { getAccountsEmailEngagement, getContactsEmailEngagement } from "../Contacts/ContactsInner/EmailEngagement/actions";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";

const ExportAnalyticsPopupStyle = styled.div<{ open?: any }>`
  ${(props) => (props.open ? "display: block;" : "display: none;")}
  position: absolute;
  top: 30%;
  left: 35%;
  border-radius: 30px;
  background-color: #ffffff;
  width: 550px;
  height: 380px;
  z-index: 11;
  opacity: 1;
  box-shadow: 0px 0px 20px 1px grey;
  padding: 45px;
  h1 {
    font-size: 42px;
    font-family: "robotomedium";
    color: #5e7079;
  }
  .upper-text {
    font-family: "robotoregular";
    font-size: 20px;
    color: #5e7079;
  }
  .lower-text {
    font-family: "robotomedium";
    font-size: 20px;
    color: #5e7079;
  }
  .close-popup {
    cursor: pointer;
    float: right;
    margin-top: -25px;
    margin-right: -25px;
  }
`;

const Wrapper = styled.div<{ open?: boolean }>`
  ${(props) => (props.open ? "display: block;" : "display: none;")}
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  /* opacity: 0.4; */
  position: fixed;
  height: 100vh;
  z-index: 10;
  top: 0;
  left: 0px;
`;

const ExportErrorWrapper = styled.div<{ open?: boolean }>`
  ${(props) => (props.open ? "display: block;" : "display: none;")}
  position: absolute;
  top: 40%;
  left: 40%;
  border-radius: 30px;
  background-color: #ffffff;
  width: 350px;
  height: 200px;
  z-index: 11;
  opacity: 1;
  padding: 45px;
  box-shadow: 0px 0px 20px 1px grey;
  h2 {
    font-size: 42px;
    font-family: "robotomedium";
    color: #5e7079;
  }
`;

interface IExportAnalyticsPopup {
  page?: string;
  searchedText?: string;
  tab?: string;
  searchTerm?: string;
  isFromAccounts?: boolean;
  status?: { value: string; label: string };
  emailsByOpens?: string;
  emailsByClicks?: string;
}

const ExportAnalyticsPopup: React.FC<IExportAnalyticsPopup> = (props: IExportAnalyticsPopup) => {
  // Props
  const { searchTerm, isFromAccounts, status, emailsByOpens, emailsByClicks } = props;

  // Redux States
  const exportEmail = useSelector((state: RootState) => state.user.userData.userEmail);
  const endDateCustom = useSelector((state: RootState) => state.analyticsGraph.endDate);
  const startDateCustom = useSelector((state: RootState) => state.analyticsGraph.startDate);
  const showExportPopup = useSelector((state: RootState) => state.analyticsDashboard.showExportPopup);
  const excludeAssetsIds = useSelector((state: RootState) => state.analyticsDashboard.excludeAssetsIds);
  const selectedEmailIds = useSelector((state: RootState) => state.accountsContentEngagement.emailIds ?? []);
  const excludeCampaignsIds = useSelector((state: RootState) => state.analyticsDashboard.excludeCampaignsIds);
  const appliedWorkflowsIds = useSelector((state: RootState) => state.analyticsDashboard.appliedWorkflowsIds);
  const showExportPopupError = useSelector((state: RootState) => state.analyticsDashboard.showExportPopupError);
  const selectedCampaignsIds = useSelector((state: RootState) => state.accountsContentEngagement.campaignIds ?? []);
  const AllCampaignsFilterCheck = useSelector((state: RootState) => state.analyticsDashboard.appliedCampaignsFilters.isAllCampaigns);
  const { isShareProfile, isDailyIQ, isWeeklyAccountInsights } = useSelector((state: RootState) => state.analyticsDashboard.appliedCampaignsFilters);

  // Local variables
  const queryCampaignId = getQueryCampaignId();

  useEffect(() => {
    const bodyElement = (document.getElementsByTagName("body") as HTMLCollectionOf<HTMLElement>)[0];
    if (showExportPopup || showExportPopupError) {
      window.scrollTo(0, 0);
      bodyElement.classList.add("overlay-nav-without-scroll");
    } else {
      bodyElement.classList.remove("overlay-nav-without-scroll");
    }
  }, [showExportPopup, showExportPopupError]);
  return (
    <>
      <Wrapper open={showExportPopup || showExportPopupError} onClick={closeAnalyticsExportPopup}></Wrapper>
      <ExportAnalyticsPopupStyle open={showExportPopup} {...props} id="export-stats-model">
        <span className="close-popup" onClick={closeAnalyticsExportPopup}>
          <img src={Cross} alt="x" />
        </span>
        <h1>Export Stats</h1>
        <p className="upper-text">
          An email has been sent to “<span id="export-email">{exportEmail}</span>” with the download link
        </p>
        <p className="lower-text">
          If you don't receive the email within 5 minutes, please check your SPAM folder as well
        </p>
        <div>
          <Button
            value={"Resend Email"}
            onClick={() => {
              if (props?.tab === 'email_engagement') {
                // to update emails ids based on filters we need to clone the arrays
                let selected_emails_ids = [...selectedEmailIds];
                let selected_campaings_ids = [...selectedCampaignsIds];
                let selected_workflows_ids = [...appliedWorkflowsIds];

                // check if is share profile || daily IQ || weekly accounts insights
                if (isShareProfile || isDailyIQ || isWeeklyAccountInsights) {
                  let campaign_email_id = getConstantCampaignEmailId({ isShareProfile, isDailyIQ, isWeeklyAccountInsights });
                  selected_campaings_ids = [campaign_email_id.toString()];
                  selected_emails_ids = [campaign_email_id.toString()];
                }
                let params = {
                  export: true,
                  end_date: endDateCustom,
                  start_date: startDateCustom,
                  ...(isFromAccounts && { campaignIds: queryCampaignId ? [queryCampaignId] : selected_campaings_ids }), // selected campaigns ids
                  ...(isFromAccounts && { emailIds: selected_emails_ids, workflowIds: selected_workflows_ids, allCampaigns: AllCampaignsFilterCheck }),
                  ...(isFromAccounts && AllCampaignsFilterCheck && { excludeCampaignsIds: excludeCampaignsIds, excludeAssetsIds: excludeAssetsIds }),
                  ...(searchTerm && { searchTerm }),
                  ...(!isFromAccounts && status && status.value !== 'Status' && { status: status.value }),
                  ...(isFromAccounts ? { account_id: getQueryAccountId() } : { contact_id: getQueryContactId() }),
                  ...(emailsByOpens && isFromAccounts ? { email_by_unique_opens: emailsByOpens } : { email_by_total_opens: emailsByOpens }),
                  ...(emailsByClicks && isFromAccounts ? { email_by_unique_clicks: emailsByClicks } : { email_by_total_clicks: emailsByClicks }),
                };
                if (isFromAccounts) {
                  getAccountsEmailEngagement(params);
                } else {
                  getContactsEmailEngagement(params);
                }
              } else getAllAnalyticsTab(props?.page, props?.searchedText, props?.tab)
            }}
          />
        </div>
      </ExportAnalyticsPopupStyle>
      <ExportErrorWrapper open={showExportPopupError}>
        <h2>Something went wrong</h2>
      </ExportErrorWrapper>
    </>
  );
};
export default ExportAnalyticsPopup;
